import {FormattedMessage} from "react-intl";
import styles from "./index.module.scss";

function TwoButton({dismiss, contents, confirmTextId, cancelTextId, confirmAction}) {
  const onClickConfirm = () => {
    if (confirmAction) confirmAction();
    dismiss();
  };
  const onClickCancel = () => {
    dismiss();
  };
  return (
    <div className={styles.container}>
      <p className={styles.contents}>{contents}</p>

      <div className={styles.btn_box}>
        <button className={styles.confirm} type="button" onClick={onClickConfirm}>
          <FormattedMessage id={confirmTextId} />
        </button>
        <button className={styles.cancel} type="button" onClick={onClickCancel}>
          <FormattedMessage id={cancelTextId} />
        </button>
      </div>
    </div>
  );
}

export default TwoButton;
